<template>
    <div>
        <div class="top-bar" data-aos="fade-down">
            <router-link to="/blog" class="back-link">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                     stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6" />
                </svg>
                بازگشت به رویدادها
            </router-link>
        </div>
        <section class="post-hero" data-aos="fade-up">
            <div class="hero-image-wrap">
                <img
                        :src="event.image || '/images/placeholder.png'"
                        :alt="event.title"
                        class="hero-image"
                        loading="lazy"
                />
                <div class="hero-overlay"></div>
                <div class="hero-meta">
                    <span class="meta-badge meta-date">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                             stroke-linecap="round" stroke-linejoin="round">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                            <line x1="16" y1="2" x2="16" y2="6" />
                            <line x1="8" y1="2" x2="8" y2="6" />
                            <line x1="3" y1="10" x2="21" y2="10" />
                        </svg>
                        {{ formatDate(event.date) }}
                    </span>
                </div>
            </div>
        </section>

        <article class="post-content" data-aos="fade-up" data-aos-delay="100">
            <div class="content-card">
                <h1 class="post-title">{{ event.title }}</h1>
                <div class="divider"></div>
                <div class="post-body" v-html="event.description"></div>
                <div class="map-cta">
                    <div class="cta-text">
                        <div class="cta-icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                 stroke-linecap="round" stroke-linejoin="round">
                                <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" />
                                <line x1="8" y1="2" x2="8" y2="18" />
                                <line x1="16" y1="6" x2="16" y2="22" />
                            </svg>
                        </div>
                        <div>
                            <h4> مشاهده روی نقشه </h4>
                            <p> این رویداد را به صورت زنده روی نقشه لایوی ببینید. </p>
                        </div>
                    </div>
                    <a :href="'/map/' + event.id" class="cta-btn" target="_blank">
                        باز کردن نقشه
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                             stroke-linecap="round" stroke-linejoin="round">
                            <path d="M19 12H5M12 5l-7 7 7 7" />
                        </svg>
                    </a>
                </div>
            </div>
            <div class="actions-bar" data-aos="fade-up" data-aos-delay="150">
                <router-link to="/blog" class="action-btn">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                         stroke-linecap="round" stroke-linejoin="round">
                        <rect x="3" y="3" width="7" height="7" />
                        <rect x="14" y="3" width="7" height="7" />
                        <rect x="14" y="14" width="7" height="7" />
                        <rect x="3" y="14" width="7" height="7" />
                    </svg>
                    همه رویدادها
                </router-link>
                <button class="action-btn" @click="copyLink" :class="{ copied: linkCopied }">
                    <svg v-if="!linkCopied" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                         stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                    </svg>
                    <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                         stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="20 6 9 17 4 12" />
                    </svg>
                    {{ linkCopied ? 'کپی شد!' : 'کپی لینک' }}
                </button>
                <a :href="event.link" class="action-btn" target="_blank">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                         stroke-linecap="round" stroke-linejoin="round">
                        <path d="M18 13v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                        <polyline points="15 3 21 3 21 9" />
                        <line x1="10" y1="14" x2="21" y2="3" />
                    </svg>
                    <span> منبع خبر </span>
                </a>
            </div>

            <div class="related-section" data-aos="fade-up" data-aos-delay="200" v-if="relatedEvents.length > 0">
                <h3 class="related-title">رویدادهای مرتبط</h3>
                <div class="related-grid">
                    <router-link
                            v-for="(rel, i) in relatedEvents"
                            :key="rel.id"
                            :to="'/blog/' + rel.slug"
                            class="related-card"
                            :data-aos-delay="i * 80"
                    >
                        <div class="related-img-wrap">
                            <img :src="rel.image || '/images/placeholder.png'" :alt="rel.title" class="related-img" loading="lazy" />
                        </div>
                        <div class="related-body">
                            <h4>{{ rel.title }}</h4>
                            <span class="related-date">{{ formatDate(rel.date) }}</span>
                        </div>
                    </router-link>
                </div>
            </div>
        </article>
    </div>
</template>

<script>
import AOS from "aos";
import { decryptResponse } from "@/utils/decrypt";
import { buildMeta, stripHtml, truncate } from "@/utils/seo";

export default {
    name: "BlogPost",
    metaInfo() {
        const title = this.event && this.event.title
            ? `${this.event.title} | لایوی`
            : "بلاگ لایوی - آخرین اخبار جهان";
        const description = this.event && this.event.description
            ? truncate(stripHtml(this.event.description))
            : "مهم‌ترین اخبار و رویدادهای جهانی را از نگاه لایوی دنبال کنید.";
        return buildMeta({
            title,
            description,
            path: `/blog/${this.$route.params.slug || ""}`,
            image: this.event && this.event.image,
            type: "article",
        });
    },
    data() {
        return {
            event: {},
            relatedEvents: [],
            linkCopied: false,
        };
    },
    computed: {},
    created() {
        AOS.init({ once: true, duration: 700, easing: "ease-out-cubic" });
    },
    async mounted() {
        await this.fetchEvent();
    },
    methods: {
        async fetchEvent() {
            try {
                const loader = this.$loading.show({ loader: "dots" });
                const slug = this.$route.params.slug;
                this.$http
                        .get(`${this.$serverUrl}/blog/${slug}`)
                        .then(async (response) => {
                            if (response.status === 200) {
                                const decrypted = JSON.parse(decryptResponse(response.data));
                                this.event = decrypted;
                                if (decrypted.related) {
                                    this.relatedEvents = decrypted.related.slice(0, 3);
                                }
                            }
                        })
                        .catch(() => {
                            this.$router.push("/blog");
                        })
                        .finally(() => {
                            loader.hide();
                            window.scrollTo({ top: 0, behavior: "smooth" });
                        });
            } catch (error) {
                console.error("Error fetching event:", error);
            }
        },
        formatDate(date) {
            if (!date) return "";
            return new persianDate(new Date(date)).format("L");
        },
        copyLink() {
            navigator.clipboard.writeText(window.location.href).then(() => {
                this.linkCopied = true;
                setTimeout(() => {
                    this.linkCopied = false;
                }, 2500);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~aos/dist/aos.css";
@import "@/assets/css/tokens";

.top-bar {
    max-width: 900px;
    margin: 0 auto;
    padding: 5.5rem 2rem 0;
}

.back-link {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.88rem;
    font-weight: 600;
    color: $text-secondary;
    text-decoration: none;
    transition: all 0.25s ease;
    padding: 0.5rem 1rem 0.5rem 0.6rem;
    border-radius: 12px;
    &:hover {
        color: $accent-blue;
        background: rgba($accent-blue, 0.05);
        svg {
            transform: translateX(3px);
        }
    }
    svg {
        transition: transform 0.25s ease;
    }
}

.post-hero {
    max-width: 900px;
    margin: 0.6rem auto 0;
    padding: 0 2rem;
}

.hero-image-wrap {
    position: relative;
    border-radius: 24px;
    overflow: hidden;
    aspect-ratio: 16 / 8;
    background: $border-light;
}

.hero-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
                    180deg,
                    transparent 50%,
                    rgba($text-primary, 0.4) 100%
    );
    pointer-events: none;
}

.hero-meta {
    position: absolute;
    bottom: 1.2rem;
    left: 1.2rem;
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.meta-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 10px;
    padding: 0.35rem 0.8rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: $text-secondary;
    direction: ltr;
    svg {
        color: $accent-blue;
        transform: translateY(-1px);
    }
}

.post-content {
    max-width: 900px;
    margin: 0 auto;
    padding: 2rem 2rem 4rem;
}

.content-card {
    background: $bg-card;
    border: 1px solid $border-light;
    border-radius: 24px;
    padding: 2.5rem 3rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03), 0 8px 30px rgba(0, 0, 0, 0.04);
}

.post-title {
    font-size: clamp(1.4rem, 3vw, 1.9rem);
    font-weight: 900;
    line-height: 1.6;
    margin: 0 0 1.2rem;
    text-align: justify;
}

.divider {
    height: 1px;
    background: linear-gradient(90deg, transparent, $border-light, transparent);
    margin-bottom: 2rem;
}

.post-body {
    font-size: 0.95rem;
    line-height: 2.2;
    color: $text-secondary;
    text-align: justify;
    word-break: break-word;
    ::v-deep {
        p {
            margin-bottom: 1.2rem;
        }
        h2,
        h3,
        h4 {
            color: $text-primary;
            font-weight: 700;
            margin: 2rem 0 0.8rem;
        }
        img {
            max-width: 100%;
            border-radius: 16px;
            margin: 1.5rem 0;
        }
        a {
            color: $accent-blue;
            text-decoration: underline;
            text-underline-offset: 3px;

            &:hover {
                color: $accent-cyan;
            }
        }
        ul,
        ol {
            padding-right: 1.5rem;
            margin-bottom: 1.2rem;
        }
        li {
            margin-bottom: 0.4rem;
        }
        blockquote {
            border-right: 4px solid $accent-blue;
            padding: 1rem 1.5rem;
            margin: 1.5rem 0;
            background: rgba($accent-blue, 0.04);
            border-radius: 0 12px 12px 0;
            color: $text-secondary;
            font-style: italic;
        }
    }
}

.map-cta {
    margin-top: 2.5rem;
    background: linear-gradient(135deg, rgba($accent-cyan, 0.05), rgba($accent-blue, 0.05));
    border: 1px solid rgba($accent-cyan, 0.12);
    border-radius: 18px;
    padding: 1.5rem 1.8rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.5rem;
    flex-wrap: wrap;
}

.cta-text {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex: 1;
    h4 {
        font-size: 0.95rem;
        font-weight: 700;
        margin: 0 0 0.2rem;
        color: $text-primary;
    }
    p {
        font-size: 0.8rem;
        color: $text-muted;
        margin: 0;
        line-height: 1.6;
    }
}

.cta-icon {
    width: 48px;
    height: 48px;
    border-radius: 14px;
    background: rgba($accent-blue, 0.1);
    color: $accent-blue;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.cta-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    background: $gradient-main;
    color: #fff;
    padding: 0.7rem 1.6rem;
    border-radius: 12px;
    font-family: "Vazirmatn", sans-serif;
    font-size: 0.88rem;
    font-weight: 700;
    text-decoration: none;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba($accent-blue, 0.2);
    white-space: nowrap;
    flex-shrink: 0;
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba($accent-blue, 0.25);
    }
}

.actions-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.6rem;
    margin-top: 1.5rem;
    flex-wrap: wrap;
}

.action-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
    background: $bg-card;
    border: 1px solid $border-light;
    border-radius: 12px;
    padding: 0.6rem 1.2rem;
    font-family: "Vazirmatn", sans-serif;
    font-size: 0.82rem;
    font-weight: 600;
    color: $text-secondary;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.25s ease;
    &:hover {
        border-color: rgba($accent-blue, 0.25);
        color: $accent-blue;
        background: rgba($accent-blue, 0.03);
        transform: translateY(-1px);
    }

    &.copied {
        border-color: rgba($accent-teal, 0.3);
        color: $accent-teal;
        background: rgba($accent-teal, 0.05);
    }
}

.related-section {
    margin-top: 3rem;
}

.related-title {
    font-size: 1.15rem;
    font-weight: 800;
    margin-bottom: 1.2rem;
    text-align: center;
}

.related-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
}

.related-card {
    background: $bg-card;
    border: 1px solid $border-light;
    border-radius: 16px;
    overflow: hidden;
    text-decoration: none;
    color: inherit;
    transition: all 0.3s ease;
    &:hover {
        transform: translateY(-4px);
        border-color: rgba($accent-cyan, 0.2);
        box-shadow: 0 8px 25px rgba($accent-blue, 0.06);

        .related-img {
            transform: scale(1.06);
        }
    }
}

.related-img-wrap {
    height: 120px;
    overflow: hidden;
}

.related-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s ease;
}

.related-body {
    padding: 0.9rem 1rem;
    h4 {
        font-size: 0.82rem;
        font-weight: 700;
        line-height: 1.7;
        margin: 0 0 0.3rem;
        color: $text-primary;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
}

.related-date {
    font-size: 0.7rem;
    color: $text-muted;
    direction: ltr;
    display: inline-block;
}

@media (max-width: 768px) {
    .top-bar {
        padding: 5rem 1.2rem 0;
    }
    .post-hero {
        padding: 0 1.2rem;
    }
    .hero-image-wrap {
        aspect-ratio: 16 / 10;
        border-radius: 18px;
    }
    .post-content {
        padding: 1.5rem 1.2rem 3rem;
    }
    .content-card {
        padding: 1.8rem 1.4rem;
        border-radius: 18px;
    }
    .map-cta {
        flex-direction: column;
        text-align: center;

        .cta-text {
            flex-direction: column;
        }
        .cta-btn {
            width: 100%;
            justify-content: center;
        }
    }
    .related-grid {
        grid-template-columns: 1fr;
    }
    .actions-bar {
        flex-direction: column;

        .action-btn {
            width: 100%;
            justify-content: center;
        }
    }
}

@media (max-width: 500px) {
    .hero-meta {
        bottom: 0.8rem;
        right: 0.8rem;
    }
}
</style>
